import { HTTP_INTERCEPTORS } from '@angular/common/http';

import { AuthInterceptor } from '@app/shared/http-interceptors/auth.http.interceptor';

export const httpInterceptorProviders = [
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
];
